import {pageRevalidate} from '@local/config'
import {ImageStrip, PersonCard, SanityImage, SearchBar} from '@local/ui/components'
import {excludeDraft, getPageById, getPageBySlug, setLocale} from 'lib/sanity'
import type {GetStaticProps} from 'next'
import Fuse from 'fuse.js'
import {useDeferredValue, useState} from 'react'
import Link from 'next/link'
import Heart from '@local/assets/svgs/heart.svg'

const People = ({props, imageStrip}) => {
	console.log(imageStrip)
	let people = props.map((item) => {
		if (item.people && item.people[0]) {
			item.people[0].slug = item.slug
			item.people[0].company = item.company[0]
			return item.people[0]
		}
		return null
	})
	people = people.filter((person) => person !== null)

	const fuse = new Fuse(people, {
		keys: [
			'personName',
		],
	})
	const [query, setQuery] = useState('')
	const deferredQuery = useDeferredValue(query)

	const results = fuse.search(deferredQuery)
	const peopleResults = deferredQuery ? results.map(result => result.item) : people

	const handleOnSearch = ({currentTarget = {}}) => {
		const {value} = currentTarget
		setQuery(value)
	}

	return (
		<div className='lg:pt-205 pt-120 grid-container'>
			<div className='flex flex-col justify-between lg:flex-row mb-65'>
				<div className='flex items-center'>
					<Heart className='w-38' />
					<h1 className='ml-12 text-36 lg:text-48'>People</h1>
				</div>
				<SearchBar query={query} handleOnSearch={handleOnSearch} />
			</div>
			<ImageStrip imageStrip={imageStrip.imageStrip} className='md-max:hidden mb-130 -margin-ml-1' />
			<div>
				{
					peopleResults?.map((person, idx) => {
						return (
							<PersonCard key={idx} slug={person.slug} {...person} />
						)
					})
				}
			</div>
		</div>
	)
}
export const getStaticProps: GetStaticProps = async ({params, locale, defaultLocale, locales, preview = false}) => {
	setLocale(locale, defaultLocale, locales)

	// TODO change page ID to articles
	const props = await getPageById('home', preview, false, /* groq */`
		'props': *[_type == 'article' ${excludeDraft(preview)}]{
  				slug,
  				'people': slices[_type == 'personInfoNative']{media, personName, socialLinks, quote},
				'company': slices[_type == 'companyInfoCard']{contact, logo, website, phone, socialLinks},

		},
		'imageStrip': *[_type == 'people'] {imageStrip}[0]
	`)

	if (!props) return {notFound: true}
	const res = {
		props: {
			...props,
			preview,
		},
		revalidate: pageRevalidate,
	}
	return res
}

export default People
